angular
  .module("AccountingBoxApp")
  .controller("DashboardCtrl", function(
    $scope,
    $rootScope,
    $http,
    $timeout,
    $filter,
    $state,
    FileUploader,
    LoopBackAuth,
    Rapporting,
    Sale,
    Purchase,
    BankTransaction,
    BankAccount
  ) {

    var vm = this;
    var currentCompany = $rootScope.currentCompany;
    // var currentYear =
    //   currentCompany.openingBalanceDate || currentCompany.startDate;
    vm.year = (moment().get("year") || 2016).toString();

    function loadDashboard() {
      Rapporting.dashboard({ year: vm.year }, function(result) {
        vm.reporting = result.rapporting;
        // console.log('dashboard reporting: ', vm.reporting);
      });
    }

    vm.yearChanged = function() {
      loadGraph();
      loadDashboard();
    };

    vm.yearChanged();

    $scope.data = {
      singleSelect: null
    };
    /*Rapporting.balanceSheet(function(result){
     vm.balance = result.balance;
     console.log('balance reporting: ',vm.balance);
     });
     Rapporting.plSheet(function(result){
     vm.profitloss = result.profitloss;
     console.log('profitloss reporting: ',vm.profitloss);
     });*/

    // var el = $('#mySelect').get(0);
    // $(el).wrap('<div class="cs-wrapper" />');
    // new SelectFx(el, {
    //   container : '#myModalID'
    // });

    $scope.$on("$destroy", function() {
      // window.stop();
      //cancels all requests when leaving screen
    });

    vm.toSale = function(sale) {
      $state.go("app.company.edit.sales", {
        id: sale.id
      });
    };
    vm.toPurchase = function(purchase) {
      $state.go("app.company.edit.purchases", {
        id: purchase.id
      });
    };
    vm.toBankTransaction = function(bankTransaction) {
      $state.go("app.company.bank.transactions", {
        id: bankTransaction.bankAccountId
      });
    };
    vm.isNegative = function(amount) {
      if (amount < 0) return true;
      else return false;
    };

    vm.toReceive = function(purchases) {
      var toReceive = 0;
      purchases.forEach(function(purchase) {
        toReceive += purchase.amountDue;
      });
      return toReceive;
    };
    vm.toPay = function(sales) {
      var toPay = 0;
      sales.forEach(function(sale) {
        toPay += sale.amountDue || 0; // fix for when sale.status==='draft'
      });
      return toPay;
    };

    vm.bankBalance = function(bankTransactions) {
      var bankBalance = 0;
      /*  bankTransactions.forEach(function(bankTransaction) {
         //   console.log('sale',bankTransaction);
         bankBalance += bankTransaction.amount;
         });*/
      vm.bankAccounts.forEach(function(bankAccount) {
        bankBalance += bankAccount.balance;
      });
      return bankBalance;
      // body...
    };
    vm.sales = Sale.find(
      {
        filter: {
          where: {status: {neq: 'paid'}},
          include: "customer",
        }
      },
      function(sales) {
        sales = _.filter(sales, function(invoice) {
          return invoice.amountDue !== 0;
        });
        vm.sales = sales;
        // body...
      }
    );
    vm.purchases = Purchase.find(
      {
        filter: {
          where: {status: {neq: 'paid'}},
          include: "vendor"
        }
      },
      function(purchases) {
        purchases = _.filter(purchases, function(invoice) {
          return invoice.amountDue !== 0;
        });
        vm.purchases = purchases;
        // body...
      }
    );

    vm.bankAccounts = BankAccount.find();

    var uploader = ($scope.uploader = new FileUploader({
      url: "/api/attachments/upload",
      headers: {
        Authorization: LoopBackAuth.accessTokenId
      }
    }));
    uploader.onAfterAddingAll = function(addedFileItems) {
      uploader.uploadAll();
      console.info("onAfterAddingAll", addedFileItems);
    };

    /*
    $scope.rickshaw_stacked_options = {
        renderer: 'area',
        stack: false,
        // unstack:true,
        // config.unstack = true;
        //multi
        height: '270%',
        //  width:800,
        padding: {
            top: 0.5
        }
    };
*/
    /* $scope.rickshaw_stacked_series = [{
        data: seriesData2[0],
        color: 'rgba(255, 255, 255, 0.9)',
        // '#2d2d2d',//$.Pages.getColor('complete-light'),
        //'#13C181',//$.Pages.getColor('complete-light'),
        name: "Omzet"
    }, {
        data: seriesData2[1],
        color: 'rgba(100, 100, 100, 0.9)',
        // color:'#2d2d2d'// $.Pages.getColor('master-light'),
        name: "Kosten"
    }, {
        data: seriesData2[2],
        color: 'rgba(60, 60, 60, 1)',
        // color: '#13C181',
        //    color: $.Pages.getColor('master-dark'),
        name: "Winst / verlies"
    }];*/
    /* $scope.rickshaw_stacked_features = {
        hover: {
            formatter: function (series, x, y) {
                var date = '<span class="date">' + moment(new Date(x * 1000)).format('MMMM YYYY') + '</span>';
                var swatch = '<span class="detail_swatch" style="background-color: ' + series.color + '"></span>';
                var content = swatch + series.name + ": € " + parseInt(y) + '<br>' + date;
                return content;
            }
        }
    };*/

    /*
    $scope.options = {
        chart: {
            type: 'discreteBarChart',
            height: 200,
            x: function (d) {
                return d.beginDate;
            },
            y: function (d) {
                return d.revenue;
            },
            color: [$.Pages.getColor('success'), $.Pages.getColor('danger'), $.Pages.getColor('primary'), $.Pages.getColor('complete'),],
            useInteractiveGuideline: true,
            transitionDuration: 300,
            xAxis: {
                tickFormat: function (d) {
                    //return d.month.month;
                    return d3.time.format('%x')(new Date(d))
                }
            },
            yAxis: {tickFormat: d3.format(',.2f')},
            showLegend: true
        }
    };
*/

    /* Chart options */
    /*
    $scope.options4 = {
        chart: {
            type: 'stackedAreaChart',
            height: 400,
            x: function (d) {
                console.log('D ISM', d);
                return d.beginDate.UTC();
            },
            y: function (d) {
                return d.revenue;
            },
            color: [
                '#13C181',
                'red',
                '#eee', //south america
                '#000', //south america

            ],
            useInteractiveGuideline: true,
            transitionDuration: 500,
            showControls: false,
            showLegend: true,
            /!* xAxis: {
             tickFormat: function(d) {
             return d3.time.format('%a')(new Date(d.begintDate));
             }
             },*!/
            yAxis: {
                tickFormat: d3.format(',.2f')
            }
        }
    };
*/
    /*$http.get('http://localhost:8080/demo/angular/assets/js/api/charts.json').success(function(data) {
     $scope.nvd3_line_data = data.nvd3.line;
     });*/
    /* Chart data */

    function loadGraph() {
      var beginDate = moment()
        .year(vm.year)
        .startOf("year")
        .toDate();
      var endDate = moment()
        .year(vm.year)
        .endOf("year")
        .toDate();
      Rapporting.revenueAndExpense(
        {
          beginDate: beginDate,
          endDate: endDate
        },
        function(result) {
          var revenue = { key: "Omzet", values: [] };
          var expense = { key: "Kosten", values: [] };
          var profit = { key: "Resultaat", values: [], disabled: false };
          // var revenue={key:'Omzet',values:result.expenseAndRevenue};
          if (result.revenueAndExpense) {
            result.revenueAndExpense.forEach(function(month) {
              month.amount = month.revenue;
              revenue.values.push(
                Object.assign({}, month, { amount: month.revenue })
              );
              expense.values.push(
                Object.assign({}, month, { amount: month.expense })
              );
              profit.values.push(
                Object.assign({}, month, {
                  amount: month.revenue - month.expense
                })
              );
            });
            $scope.data = [revenue, expense, profit];
            initializeChart();
          }
        }
      );
    }

    function initializeChart() {
      nv.addGraph(function() {
        var chart = nv.models.multiBarChart();

        chart.margin().left = 80;

        chart.x(function(d) {
          return moment(d.beginDate).format("MMMM");
          // return d.month;
        });

        chart.y(function(d) {
          return d.amount;
        });

        var euroFormat = function(d) {
          return $filter("currency")(d, "EUR", 2);
        };

        chart.yAxis.tickFormat(euroFormat);

        chart.color([
          "#172B4D",
          "rgba(150, 150, 150, 0.4)",
          "rgba(21, 200, 112, 1)"
        ]);

        // chart.color(function(d, y, e){
        //   console.log('d is',d);
        //   console.log('y is',y);
        //   console.log('e is',e);
        //   return 'rgba(0, 0, 0, 0.9)';
        // });
        chart.groupSpacing(0.6);
        chart.showControls(false);

        chart.tooltipContent(function(key, y, e, graph) {
          var data = graph.series.values[y - 1];
          var rows =
            "<tr>" +
            "<td class='key'>" +
            y +
            "</td>" +
            "<td class='x-value'>" +
            e +
            "</td>" +
            "</tr>";

          var header =
            "<thead>" +
            "<tr>" +
            "<td class='key'><strong>" +
            key +
            "</strong></td>" +
            "</tr>" +
            "</thead>";

          return (
            "<table>" + header + "<tbody>" + rows + "</tbody>" + "</table>"
          );
        });

        // chart.barColor(["#FF0000","#00FF00","#0000FF"])
        // chart.barColor(function (d, i) {
        //     var colors = d3.scale.category20().range().slice(10);
        //     return colors[i % colors.length-1];
        // })
        //

        d3.select("#chart svg")
          .datum($scope.data)
          .transition()
          .duration(500)
          .call(chart);

        nv.utils.windowResize(chart.update);

        return chart;
      });
    }
  });
